const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
const capitalizeWords = (str) => typeof str === 'string'
    ? str.split(' ').map(capitalizeFirstLetter).join(' ')
    : str;
const normalizersByKey = {
    name: capitalizeWords,
    firstName: capitalizeWords,
    lastName: capitalizeWords,
};
export const normalizeToken = (decoded) => Object.entries(decoded).reduce((obj, [key, value]) => (Object.assign(Object.assign({}, obj), { [key]: Object.keys(normalizersByKey).includes(key)
        ? normalizersByKey[key](value)
        : value })), {});
export default normalizeToken;
